import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccionesDialog } from '@models/base/identificadores.model';
import { CreateCaracteristicaRequest } from '@models/caracteristica-propiedad/createCaracteristicaRequest.model';
import { UpdateCaracteristicaRequest } from '@models/caracteristica-propiedad/updateCaracteristicaRequest.model';
import { TipoCaracteristicaPropiedadDto } from '@models/propiedades/tipoCaracteristicaPropiedadDto.model';
import { CaracteristicasPropiedadService } from '@services/caracteristicas-propiedad/caracteristicas-propiedad.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogTipoCaracteristicaComponent } from '../dialog-tipo-caracteristica/dialog-tipo-caracteristica.component';

@Component({
  selector: 'app-tipos-caracteristica',
  templateUrl: './tipos-caracteristica.component.html',
  styleUrls: ['./tipos-caracteristica.component.css']
})
export class TiposCaracteristicaComponent implements OnInit {
  data = false
  dataSource = new MatTableDataSource<TipoCaracteristicaPropiedadDto>();
  obj!: undefined
  displayedColumns: string[] = ['descripcion', 'accion'];

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }


  constructor(
    public dialog: MatDialog,
    private caracteristicasPropiedadService: CaracteristicasPropiedadService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['descripcion', 'accion'] :
        ['descripcion', 'accion'];
    });
  }


  ngOnInit() {
    this.listadTiposCaracteristicas();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  listadTiposCaracteristicas() {
    this.spinner.show()
    this.caracteristicasPropiedadService.getAll()
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data = data.sort((a, b) => a.descripcion.toString().localeCompare(b.descripcion.toString()))
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide();
          this.snackBar.showError(error, "Error");
        }
      )
  }

  openDialog(action: any, obj: { action?: any; }) {
    obj.action = action;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = obj
    dialogConfig.width = "30%"
    const dialogRef = this.dialog.open(DialogTipoCaracteristicaComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == AccionesDialog.Agregar) {
        this.addRowData(result.data);
      } else if (result && result.event == AccionesDialog.Modificar) {
        this.updateRowData(result.data);
      } else if (result && result.event == AccionesDialog.Eliminar) {
        this.deleteRowData(result.data);
      }
    });
  }

  applyFilter(event: any) {
    if (event && event.target && event.target.value !== undefined) {
const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
}
  }


  addRowData(row_obj: { descripcion: any; }) {
    this.spinner.show()
    let id = null
    let createCaracteristicaRequest = new CreateCaracteristicaRequest
    createCaracteristicaRequest.descripcion = row_obj.descripcion
    this.caracteristicasPropiedadService.create(createCaracteristicaRequest)
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data.push({
            id: data.id,
            descripcion: row_obj.descripcion
          });
          this.table.renderRows();
          this.dataSource.data = this.dataSource.data.filter((value: { id: number; descripcion: string; }, key: any) => {
            return true;
          });
          this.data = this.dataSource.data.length >= 1 ? true : false
          this.snackBar.showSuccess("Se agrego el registro de manera correcta.", "");
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )


  }
  updateRowData(row_obj: { id: number; descripcion: string; }) {
    this.spinner.show()
    let updateCaracteristicaRequest = new UpdateCaracteristicaRequest
    updateCaracteristicaRequest.id = row_obj.id
    updateCaracteristicaRequest.descripcion = row_obj.descripcion
    this.caracteristicasPropiedadService.update(updateCaracteristicaRequest)
      .subscribe(
        data => {
          this.spinner.hide()
          this.dataSource.data = this.dataSource.data.filter((value: { id: number; descripcion: string; }, key: any) => {
            if (value.id == row_obj.id) {
              value.descripcion = row_obj.descripcion;
            }
            return true;
          });
          this.data = this.dataSource.data.length >= 1 ? true : false
          this.snackBar.showSuccess("Se actualizo el registro de manera correcta.", "");
        },
        error => {
          this.spinner.hide()
          this.snackBar.showError(error, "Error");
        }
      )

  }


  deleteRowData(row_obj: { id: number; }) {
    this.caracteristicasPropiedadService.delete(row_obj.id)
        .subscribe(
          data => {
            this.spinner.hide()
            this.dataSource.data = this.dataSource.data.filter((value: { id: number; }, key: any) => {
              return value.id != row_obj.id;
            });
            this.data = this.dataSource.data.length >= 1 ?  true : false
            this.snackBar.showSuccess("Registro dado de baja correctamente.", "Exito");
          },
          error => {
            this.spinner.hide()
            this.snackBar.showError( error, "Error");
          })

  }

}
